
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { Alert } from "@/addons/Alert";
import { DateTime } from "luxon";
import { useConsultorioStore } from '@/store/consultorioStore';
import { globalStore } from '@/store/globalStore';
import { consultorioService } from '@/services/ConsultorioService';
import { http } from "@/config/HttpClient";
import { AxiosResponse } from "axios";

@Component({
	name: "RecetasIndex",
})

export default class ReconsultasIndex extends Vue {
	@Prop() paciente_id!: any
	private globalStore = globalStore();
	private consultorioStore = useConsultorioStore();
	private consultorioService = consultorioService.getInstance();

	detalleInterface = {
		medicamento: String,
		posologia: String
	}
	reconsulta = {
		id: '',
		fecha: DateTime.now().toFormat("yyyy-MM-dd"),
		hora: DateTime.now().toFormat("HH:mm"),
		consulta_id: '',
		detalle: '',
		subjetivo: '',
		objetivo: '',
		apreciacion: '',
		plan: '',
		es_pago: false
		
	}
	
	valid = true;
	fecha = DateTime.now().toFormat('yyyy-MM-dd');
	receta = {
		fecha: DateTime.now().toFormat('yyyy-MM-dd'),
		consulta_id: null
	}
	recetas = []
	detalles = []
	mounted() {
		this.getReconsultas()
	}
	async getReconsultas() {
		this.consultorioStore.loading = true;
		this.consultorioService.getReconsultas(this.paciente_id);
	}
	
	guardar() {
		if (!this.$refs.form.validate()) {
			Alert.warning(`Lene todos los campos obligatorios (*)`)
			return;
		}

		Alert.confirm(`Se realizará el registro de la reconsulta`, 'Guardar Reconsulta?').then(async result => {
			if (result.isConfirmed) {
				let data = {
					fecha: this.receta.fecha,
					consulta_id: this.receta.consulta_id,
					detalles: this.detalles,
					paciente_id: this.paciente_id
				}
				this.consultorioService.registrarReconsulta(this.reconsulta).then(response => {
					this.limpiar();
					this.getReconsultas();
				})
			}
		})
	}
	selectItem(detalle: any) {
		this.detalles = detalle
	}

	get loading(): boolean {
		return this.consultorioStore.loading;
	}
	get reconsultas(): any {
		return this.consultorioStore.reconsultas;
	}
	get consultas(): any {
		return this.consultorioStore.consultas;
	}
	imprimir = (id: number) => {
		return this.consultorioService.imprimirSolicitud(id)
	}
	limpiar() {
		console.log('llegaaaaa');
		this.reconsulta = {
			id: '',
			fecha: DateTime.now().toFormat("yyyy-MM-dd"),
			hora: DateTime.now().toFormat("HH:mm"),
			consulta_id: '',
			detalle: '',
			subjetivo: '',
			objetivo: '',
			apreciacion: '',
			plan: '',
			es_pago: false
		}
	}
	eliminarReconsulta(id: any) {
		console.log(id);
		Alert.confirm(`Se eliminara la reconsulta`, 'Eliminar Reconsulta?').then(async result => {
			if (result.isConfirmed) {
				this.consultorioService.eliminarReconsulta(id).then(response => {
					this.getReconsultas();
				})
			}
		})
	}


}

